
import * as ipxRuntime$qxscdhA6z7 from 'E:/shuzilvtu/gvi-mall/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 60
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$qxscdhA6z7, defaults: {} }
}
        